module.exports = __webpack_public_path__ + "static/media/(V)-SLS_5415_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Acessorios.0d1ea68d.jpg";